import React from 'react'
import PropTypes from 'prop-types'

import IconButton from 'components/common/IconButton'
import { ICON_LOCATION } from 'components/common/Icon'

const LocationButton = ({ text, ...rest }) => {
  return <IconButton icon={ICON_LOCATION} text={text} {...rest} />
}

LocationButton.propTypes = {
  text: PropTypes.string.isRequired
}

export default LocationButton



// WEBPACK FOOTER //
// ./src/components/common/LocationButton.js